import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import PageTitleWithBackButton from '../../components/PageTitleWithBackButton/PageTitleWithBackButton';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import {
  countriesIsoCodes,
} from '../../constants/countries';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  ICountry,
} from '../../mobx-store/storeInterfaces/authInterface';
import {
  IHomeStore,
} from '../../mobx-store/storeInterfaces/homeInterface';
import {
  CountryStore,
} from '../../mobx-store/stores/countryStore';
import classes from './home.module.scss';

interface IProps extends WithSnackbarProps {
  homeStore: IHomeStore;
  countryStore: CountryStore;
  history: any;
  match: any;
}

@inject('homeStore')
@inject('countryStore')
@observer
class Home extends Component<IProps> {
  addButton: any;

  tableHeader: any = [];

  tableData: any[] = [];

  tableCellTypes: TableCellTypes[] = [];

  isEgypt = false;

  title: string;

  categoryId: number;

  restaurantId: number;

  constructor(props: IProps) {
    super(props);
    this.title = translate('homeListPageTitle', {
    });
    this.categoryId = this.props.match.params.categoryId;
    this.restaurantId = this.props.match.params.restaurantId;
    console.log(this.categoryId);
  }

  handleTableToggleCellChange = (index: number, key: string, value: boolean) => {
    this.props.homeStore.updateHomeCardStatus(value, index)
      .then(() => {
        SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
        }), 8000, 'success');
      })
      .catch((error: any) => {
        SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
        }), 8000, 'error');
      });
  };

  handleTableToggleCellChangePrivacy = (index: number, key: string, value: boolean) => {
    console.log(index, value);
    this.props.homeStore.updateHomeCardPrivacy(value, index)
      .then(() => {
        SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
        }), 8000, 'success');
      })
      .catch((error: any) => {
        SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
        }), 8000, 'error');
      });
  };

  handleTableButtonCellClicked = (index: number, key: string) => {
    this.props.history.push(
      `/home/${this.props.homeStore.homeList[index].cardId}`,
    );
  };

  handleTableItemsButtonCellClicked = (index: number, key: string) => {
    // this.props.history.push(
    //   `/restaurants/${this.restaurantId}/categories/${this.categoryId}/homes/${this.props.homeStore.homeList[index].mealId}/Items`
    // );
  };

  handelAdd = (): void => {
    this.props.history.push('/new');
  };

  getAddMenuButton = () => ({
    title: translate('addButton', {
    }),
    onAdd: this.handelAdd,
  });

  getMenuTableHeader = () => {
    const tableHeaders = [
      {
        title: translate('homeListCategoryColumnTitle', {
        }),
      },
      {
        title: translate('homeListStatusColumnTitle', {
        }),
      },
      {
        title: 'Privacy',
      },
    ];
    if (this.isEgypt) {
      return tableHeaders;
    }
    return tableHeaders.slice(0, tableHeaders.length - 1);
  };

  getMenuTableData = () => this.props.homeStore.homeList
    .map((home) => ({
      ...home,
      items: translate('homeListItemsButton', {
      }),
      edit: translate('homeListEditButton', {
      }),
    }));

  renderList = (data: any) => {
    switch (data.type) {
      case 1:
        return (
          <div className={classes.flexColumn}>
            {data.article && data.article.imageURL && (
            <div className={classes.containerCard}>
              <div className={classes.bodyContainer}>
                <p className={classes.title}>{data.article.title}</p>
                <div className={classes.seprator} />
                <p className={classes.preview}>{data.article.preview}</p>
              </div>
              <div
                style={{
                  backgroundImage: `url(${data.article.imageURL.replace('(', '%28').replace(')', '%29')})`,
                  backgroundSize: 'cover',
                  alignItems: 'flex-start',
                  justifyContent: 'flex-end',
                  width: '50%',
                }}
                className={classes.imageContainer}
              />
            </div>
            )}

          </div>
        );
        break;
      case 2:
        // console.log(data.ad, data.ad.backgroundImage[0].imageUrl)
        return (
          <div className={classes.flexColumn}>
            {data.imageURL
                    && (
                    <div className={classes.containerCard}>
                      <div
                        style={{
                          backgroundImage: `url(${data.imageURL.replace('(', '%28').replace(')', '%29')})`,
                          backgroundSize: 'cover',
                          alignItems: 'flex-start',
                          justifyContent: 'flex-end',
                          width: '100%',
                        }}
                        className={classes.imageContainer}
                      />
                    </div>
                    )}

          </div>
        );
        break;
      case 3:
        return (
          <div className={classes.flexColumn}>
            <div className={classes.largeContainerCard}>
              {data.article && data.article.imageURL && (
              <div className={classes.containerWidth}>
                <div
                  style={{
                    backgroundImage: `url(${data.article.imageURL.replace('(', '%28').replace(')', '%29')})`,
                    backgroundSize: 'cover',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-end',
                    width: '100%',
                    height: '50%',
                  }}
                  className={classes.imageContainer}
                />
                <div className={classes.bodyContainerVertical}>
                  <p className={classes.title}>{data.article.title}</p>
                  <div className={classes.seprator} />
                  <p className={classes.preview}>{data.article.preview}</p>
                </div>
              </div>
              )}
              {data.link.data.imageURL && (
              <div className={classes.containerWidth}>
                <div
                  style={{
                    backgroundImage: `url(${data.link.data.imageURL.replace('(', '%28').replace(')', '%29')})`,
                    backgroundSize: 'cover',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-end',
                    width: '100%',
                    height: '100%',
                  }}
                  className={classes.imageContainer}
                />
              </div>
              )}
            </div>
          </div>
        );
        break;
      case 4:
        return (
          <div className={classes.flexColumn}>
            <div className={classes.largeContainerCard}>
              {data.articles && data.articles.length > 0 && (
              <div className={classes.containerWidth}>
                <div
                  style={{
                    backgroundImage: `url(${data.articles[0].imageURL.replace('(', '%28').replace(')', '%29')})`,
                    backgroundSize: 'cover',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-end',
                    width: '100%',
                    height: '50%',
                  }}
                  className={classes.imageContainer}
                />
                <div className={classes.bodyContainerVertical}>
                  <p className={classes.title}>{data.articles[0].title}</p>
                  <div className={classes.seprator} />
                  <p className={classes.preview}>{data.articles[0].preview}</p>
                </div>
              </div>
              )}
              {data.articles && data.articles.length > 0 && (
              <div className={classes.containerWidth}>
                <div
                  style={{
                    backgroundImage: `url(${data.articles[1].imageURL.replace('(', '%28').replace(')', '%29')})`,
                    backgroundSize: 'cover',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-end',
                    width: '100%',
                    height: '50%',
                  }}
                  className={classes.imageContainer}
                />
                <div className={classes.bodyContainerVertical}>
                  <p className={classes.title}>{data.articles[1].title}</p>
                  <div className={classes.seprator} />
                  <p className={classes.preview}>{data.articles[1].preview}</p>
                </div>
              </div>
              )}
            </div>
          </div>
        );
        break;
      default:
        return (null);
    }
  };

  getMenuTableCellTypes = (): TableCellTypes[] => {
    const tableCells: any = [
      {
        cellType: 'render',
        key: 'render',
        render: (data: any) => (<div>{this.renderList(data)}</div>),
      },
      {
        cellType: 'ToggleButton',
        key: 'isActive',
        activeLabel: translate('homeListStatusActive', {
        }),
        inactiveLabel: translate('homeListStatusInactive', {
        }),
        onChange: this.handleTableToggleCellChange,
      },
      {
        cellType: 'ToggleButton',
        key: 'isPrivate',
        activeLabel: 'Members Only',
        inactiveLabel: 'Public',
        onChange: this.handleTableToggleCellChangePrivacy,
      },
    ];
    if (this.isEgypt) {
      return tableCells;
    }
    return tableCells.slice(0, tableCells.length - 1);
  };

  render() {
    this.addButton = this.getAddMenuButton();
    this.tableHeader = this.getMenuTableHeader();
    this.tableData = this.getMenuTableData();
    this.tableCellTypes = this.getMenuTableCellTypes();
    console.log(this.props.homeStore.homeList);
    return (
      <div>
        <PageTitleWithBackButton history={this.props.history} pageTitle={this.title} />
        <GeneralTableComponent
          emptyMessage={translate('homeListNoCategoriesMessage', {
          })}
          tableHeader={this.tableHeader}
          tableData={this.tableData}
          tableCellTypes={this.tableCellTypes}
          addButton={this.addButton}
          loadingStatus={[
            this.props.homeStore.getHomeCardsRequestStatus,
            this.props.countryStore.getManagedCountriesRequestStatus
          ]}
        />
      </div>
    );
  }

  async componentDidMount() {
    const {
      countryStore,
    } = this.props;
    await countryStore.getUserManagedCountries();
    this.setState({
      loadingManagedCountries: false,
    });
    if (countryStore.managedCountries.some((country: ICountry) => country.isoCode === countriesIsoCodes.egypt)) {
      this.isEgypt = true;
    }
    this.props.homeStore.getHome(countryStore.managedCountries);
  }
}

export default Home;
